import { render, staticRenderFns } from "./StudentFinalExam.vue?vue&type=template&id=d4b306c6&scoped=true"
import script from "./StudentFinalExam.vue?vue&type=script&lang=js"
export * from "./StudentFinalExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b306c6",
  null
  
)

export default component.exports